import React from 'react';
import moment from 'moment';
import { Card } from 'react-toolbox/lib/card';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import VisibilitySensor from 'react-visibility-sensor';
import DatePicker from '~/components/DatePicker';

import Spinner from '~/components/Spinner';

import { list } from '~/actions/logs';
import { findUserById, listUsers } from '~/actions/user';

import Styles from './users.scss';

class Logs extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    const from = new Date();
    from.setDate(from.getDate() - 1);
    from.setHours(1);
    from.setMinutes(0);
    from.setSeconds(0);
    const to = new Date();
    to.setHours(23);
    to.setMinutes(0);
    to.setSeconds(0);

    this.state = {
      from,
      to,
      reset: true,
      search: '',
      skip: 0,
      loading: true
    };
  }
  componentDidMount() {
    listUsers(this.props.dispatch, this.context.apiClient).then(() => {
      // this.loadLogs();
    });
  }

  getUser(username) {
    if (username === 'system') {
      return username;
    }
    const users = (this.props.users && this.props.users.toJS()) || {};
    if (users[username]) {
      return users[username].name;
    }

    // no such user lets load it and return loading
    findUserById(this.props.dispatch, this.context.apiClient, username);
    return 'loading';
  }

  loadLogs() {
    const skip = this.props.list.count();
    this.setState({ loading: true }, () => {
      list(
        this.props.dispatch,
        this.context.apiClient,
        this.state.from,
        this.state.to,
        skip,
        this.state.reset
      ).then(() => {
        this.setState({ reset: false, loading: false });
      });
    });
  }

  renderLogs(logs) {
    const { search } = this.state;
    const seekRegex = new RegExp(search, 'i');

    return logs.map(item => {
      if (seekRegex.exec(item.method)) {
        return (
          <tr key={item.logId}>
            <td>
              <div className={Styles.spacer} />
            </td>
            <td>{item.method}</td>
            <td>{moment(item.createDate).format('LLL')}</td>
            <td>{this.getUser(item.user)}</td>
            <td>
              <pre>{JSON.stringify(item.msg, false, 2)}</pre>
            </td>
          </tr>
        );
      }
      return false;
    });
  }
  render() {
    const logs = (this.props.list && this.props.list.toJS()) || false;
    return (
      <div className={Styles.content}>
        <div className={Styles.actionBar}>
          <div className={Styles.searchBox}>
            <Input
              type="text"
              label="Filter"
              icon="search"
              value={this.state.search}
              onChange={e => this.setState({ search: e })}
            />
          </div>
          <div className={Styles.actionBox}>
            <div style={{ width: '50%', float: 'left' }}>
              <DatePicker
                label="From"
                locale="us"
                sundayFirstDayOfWeek
                onChange={from => {
                  this.setState({ from, reset: true }, () => {
                    this.loadLogs();
                  });
                }}
                value={this.state.from}
              />
            </div>
            <div style={{ width: '50%', float: 'left' }}>
              <DatePicker
                label="To"
                locale="us"
                sundayFirstDayOfWeek
                onChange={to => {
                  this.setState({ to, reset: true }, () => {
                    this.loadLogs();
                  });
                }}
                value={this.state.to}
              />
            </div>
          </div>
        </div>
        <div className={Styles.cardBox}>
          <Card>
            <div className={Styles.orderTitle}>Logs</div>
            <table className={Styles.table}>
              <thead>
                <tr>
                  <th>
                    <div className={Styles.spacer} />
                  </th>
                  <th>Action</th>
                  <th>When</th>
                  <th>Who</th>
                  <th>Payload</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {(logs && this.renderLogs(logs)) || <div>Loading</div>}
              </tbody>
            </table>
            {this.state.loading && <Spinner />}
            <VisibilitySensor
              onChange={isVisible => {
                if (isVisible) {
                  this.loadLogs();
                }
                console.log(isVisible);
              }}
            />
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.getIn(['logs', 'list'], {}),
  pending: state.getIn(['logs', 'pending'], true),
  users: state.getIn(['user', 'users'], false)
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(Logs);



// WEBPACK FOOTER //
// ./app/pages/Logs/index.js